import * as Cookiebanner from "./Events/cookiebanner"
import * as Subnav from "./Events/subnav"
import * as VariantSelector from "./Events/variantSelector"
import * as Polyfills from "./Events/polyfills"
import * as InformationTabs from "./Events/informationTabs"
import * as PdfCheckout from "./Events/pdfcheckout"
import * as lightCalculation from "./Events/lightcalculation"
import * as pictogramTooltip from "./Events/pictogramTooltip"

export function init() {
    Polyfills.init();
    Cookiebanner.init();
    Subnav.init();
    VariantSelector.init();
    InformationTabs.init();
    PdfCheckout.init();
    lightCalculation.init();
    pictogramTooltip.init();
}
